import { Item } from "react-bootstrap/lib/Breadcrumb";
import { API_ENDPOINTS } from "../../../Api/apiEndPoints";
import axiosInstance from "../../../Api/axiosInstance";
import { toast } from "react-toastify";

export const getSurveyList = async (params={})=>{

    const url =`${API_ENDPOINTS.SURVEY.GET_SURVEY_LIIST}` 
    let response = await axiosInstance.get(url,{params});
    const rowData  = response?.data;
    // console.log('rowDataSurvey',rowData);
    const formatedData = Array.isArray(rowData?.data?.data)?
    rowData.data.data.map((item:any)=>({
        StartDate:item.StartDate || '-',
        SurveyId:item.SurveyId ||'-',
        name:item.SurveyName || '-',
        SurveyName:item.SurveyName || null,
        Status:item.Status || "-",
        EndDate:item.EndDate || '-',
        AudienceType:item.AudienceType || '-',
        MediaId:item.MediaId || '-',
        Multiple:item?.IsMultiple,
        survey_category_name:item.SurveyCategory?.SurveyCatName ||'-',
        ShortCode:item.ShortCode || '-',
        OutletTypeId:item.OutletTypeId ||'-',
        Orgunitid:item.Orgunitid || '-',
        SurveyCatid:item.SurveyCategory?.SurveyCatid ||'-'
        

    })):[]
    return{formatedData,rowData};
}


export const getOutletTypes =  async ()=>{
    let response = await axiosInstance.get(API_ENDPOINTS.SURVEY.GET_OUT_LET_TYPES);
    const rowData = response?.data;

    const formatedata =   Object.entries(response?.data?.data || {}).map(([key,value])=>({
        id:key,
        label:String(value)
    }))
    return {rowData,formatedata};
}

export const getSurvey_Category_Type = async()=>{
  let response = await axiosInstance.get(API_ENDPOINTS.SURVEY.GET_SURVEY_CATEGROY_TYPE);
  const rowData = response?.data;

  const formatedData  = Array.isArray(rowData?.data)?
  rowData?.data.map((item:any)=>({
    id:item.ConfigKey,
    label:item.ConfigValue
  })):[]

  return {rowData,formatedData}
}



export const getStatusActiveInActive = async ()=>{
    const response = await axiosInstance.get(API_ENDPOINTS.Subscriber.GET_STATUS_OPTIONS);
    const rowData = await response?.data;
    const formatedata = Object.entries(response?.data?.data?.Status ||{}).map(([Key,value])=>({
        id:Key,
        label:String(value),
    }))
    return {rowData,formatedata};

}

export const getSurveyConfiguration =async()=>{
    let response = await axiosInstance.get(API_ENDPOINTS.SURVEY.GET_SURVEYCONFIGURATION);
    const rowData = await response?.data;
 

    //AudienceType
    const formatedData =  Object.entries(rowData.data[3].ConfigValue ||{} ).map(([id,label])=>({
        id:id,
        label: String(label),
    }));

    const formatedData_IsMultiple = Object.entries(rowData.data[2].ConfigValue ||{} ).map(([id,label])=>({
        id:id,
        label: String(label),
    }));
    const formatedData_SurveyQuesTypes = Object.entries(rowData.data[0].ConfigValue ||{} ).map(([id,label])=>({
        id:id,
        label: String(label),
    }));

    const formatedData_SurveyStatus = Object.entries(rowData.data[1].ConfigValue ||{} ).map(([id,label])=>({
        id:id,
        label: String(label),
    }));

    const formatedData_SurveyRequired = Object.entries(rowData.data[4].ConfigValue ||{} ).map(([id,label])=>({
        id:id,
        label: String(label),
    }));
    
    const formatedData_SurveyFor = Object.entries(rowData.data[5].ConfigValue ||{} ).map(([id,label])=>({
        id:id,
        label: String(label),
    }));
    return {formatedData_SurveyFor,formatedData_SurveyRequired,formatedData_SurveyStatus,formatedData,rowData,formatedData_IsMultiple,formatedData_SurveyQuesTypes};
}   

export const AddSurvey = async(ReqBody:any)=>{
    const url = `${API_ENDPOINTS.SURVEY.POST_ADD_SUVERY}`
    let response = await axiosInstance.post(url,ReqBody);
    return response;
}

export const UpdateSurvey = async(ReqBody:any)=>{
    const url = `${API_ENDPOINTS.SURVEY.PUT_UPDATE_SURVEY}`
    let response = await axiosInstance.put(url,ReqBody);
}

export  const getSurveyQuestion = async(SurveyID:number,params={})=>{
    const url  = `${API_ENDPOINTS.SURVEY.GET_SURVEY_QUESTION_LIST}/${SurveyID}`

    let response = await axiosInstance.get(url,{params});
    const rowData = await response?.data;
    const formatedData = Array.isArray(rowData.data?.data)?
    rowData.data?.data.map((item:any)=>({
       survey_question_type:item.Surveyquestype ||'-',
       survey_question_options:item.Surveyquestionopt || '-',
       survey_question:item.Question ||'-',
       survey:item.Survey.SurveyName ||'-',
       status:item.Status ||'-',
       SurveyId:item.SurveyId ||'-',
       Surveyquesid:item.Surveyquesid ||'-',
       IsRequired:item.IsRequired || '-',
       MediaId:item.MediaId ||'-',
    })):[]

    return{rowData,formatedData}
} 


export const AddSurveyQuestion = async(ReqBody:any,SurveyId:number| null)=>{
    const url = `${API_ENDPOINTS.SURVEY.POST_ADD_SERVEY_QUESTION}/${SurveyId}`;
    const respone = await axiosInstance.post(url,ReqBody)
}

export const UpadteSurveyQuestion = async(ReqBody:any,survey_ques_id: number | null)=>{
    
    const url = `${API_ENDPOINTS.SURVEY.PUT_UPDATE_SERVEY_QUESTION}/${survey_ques_id}`;
    const respone = await axiosInstance.put(url,ReqBody)
}

export const getCategoryList = async()=>{
    let response =  await axiosInstance.get(API_ENDPOINTS.SURVEY.GET_CATEGORY_LIST);
    const rowData = await response?.data;
    console.log('CAtegory List response ::',rowData?.data);

    const formateData = Array.isArray(rowData?.data)?
        [  
        ...[{id:'',label:'All'}],
        ...( rowData?.data.map((item:any)=>({
             id:item.SurveyCatid,
             label:item.SurveyCatName
            })))

        ]:[]
        // console.log("🚀 ~ getCategoryList ~ formateData:", formateData)

        return{rowData,formateData};
}
